import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'valueByKey',
})
export default class ValueByKeyPipe implements PipeTransform {
  /**
   * Get a value of object even if the key is a nested one.
   * @param values - the input object.
   * @param key - a simple key or nested one (e.g foo.bar.boo)
   * @returns - object value
   */
  transform(values: Object, key: string, defaultValue?: any) {
    const keys = key.split('.');

    let currentValue = values;

    for (const element of keys) {
      if (currentValue?.[element]) {
        currentValue = currentValue[element];
      } else {
        return defaultValue ?? undefined;
      }
    }

    return currentValue;
  }
}
